import { ReactNode } from "jsx-dom";
import { defaultClasses } from "./buttonStyles";

export type ButtonProps = {
  children: ReactNode;
  cssClass?: string;
  disabled?: boolean;
  testId?: string;
  onClick?: () => void;
};

export const Button = ({
  children,
  cssClass,
  disabled,
  testId,
  onClick,
}: ButtonProps) => {
  return (
    <button
      data-testid={testId}
      disabled={disabled}
      className={`${defaultClasses} ${cssClass}`}
      onClick={() => onClick && onClick()}
    >
      {children}
    </button>
  );
};
